interface QueryLike {
  path?: string;
  dataSource?: string;
}

const BY_PREFIX: Record<string, string> = {
  snowflake: 'Snowflake',
  sf: 'Salesforce',
  salesforce: 'Salesforce',
  moodle: 'Moodle',
  db: 'the Toolbox database',
};

const BY_SOURCE: Record<string, string> = {
  snowflake: 'Snowflake',
  salesforce: 'Salesforce',
  moodle: 'Moodle',
  'toolbox db': 'the Toolbox database',
  joomla: 'Joomla',
  firestarter: 'Firestarter',
};

/** Which system a tile query reads from, taken from its endpoint prefix (`snowflake/`, `sf/`, `db/`) or its data source name. */
export function sourceOfQuery(q: QueryLike): string | null {
  const prefix = String(q?.path || '').replace(/^\/+/, '').split('/')[0].toLowerCase();
  if (BY_PREFIX[prefix]) return BY_PREFIX[prefix];
  return BY_SOURCE[String(q?.dataSource || '').trim().toLowerCase()] ?? null;
}

/** "Snowflake", "Snowflake and Salesforce", "Snowflake, Salesforce and the Toolbox database"; empty when nothing is known. */
export function describeDataSources(queries: QueryLike[] | null | undefined): string {
  const names = Array.from(new Set((queries ?? []).map(sourceOfQuery).filter((s): s is string => !!s)));
  if (names.length <= 1) return names[0] ?? '';
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}
